import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebcallbackService {

  constructor(private httpClient: HttpClient) { }

  demanderRappel(numTel: string): Observable<any> {
    const body = {
      numTel: numTel
    }
    return this.httpClient.put(`${environment.apiUrl}/rappel`, body);
  }

  extractionRappels(): Observable<any> {

    return this.httpClient.get(`${environment.apiUrl}/extraction-rappels`);
  }
}
